import styled from 'styled-components'

// Overlay semi-trasparente dietro il drawer
export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => props.theme.colors.shadow.overlay};
  z-index: 9998;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
  cursor: pointer;
`

// Container principale del drawer
export const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 500px;
  background: ${props => props.theme.colors.background.primary};
  box-shadow: -4px 0 20px ${props => props.theme.colors.shadow.strong};
  transform: translateX(${props => props.isOpen ? '0' : '100%'});
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100vw;
  }
`

// Header fisso con search e close
export const DrawerHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid ${props => props.theme.colors.border.light};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-shrink: 0;
  background: ${props => props.theme.colors.background.primary};
`

// Row per titolo + close button
export const DrawerHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

// Titolo drawer
export const DrawerTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
  margin: 0;
  font-family: ${props => props.theme.typography.fontFamily};
`

// Close button
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.text.secondary};
  cursor: pointer;
  padding: 0.5rem;
  border-radius: ${props => props.theme.radius.button};
  transition: ${props => props.theme.transitions.default};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${props => props.theme.colors.background.hover};
    color: ${props => props.theme.colors.text.primary};
  }
`

// Search input container
export const SearchContainer = styled.div`
  position: relative;
`

// Search input
export const SearchInput = styled.input`
  width: 100%;
  padding: 0.625rem 0.875rem 0.625rem 2.5rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  font-size: 0.875rem;
  font-family: ${props => props.theme.typography.fontFamily};
  background: ${props => props.theme.colors.background.secondary};
  color: ${props => props.theme.colors.text.primary};
  transition: ${props => props.theme.transitions.default};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    background: ${props => props.theme.colors.background.primary};
  }

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
  }
`

// Search icon
export const SearchIcon = styled.div`
  position: absolute;
  left: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.text.tertiary};
  pointer-events: none;
  display: flex;
  align-items: center;
`

// Body scrollabile
export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`

// Footer fisso con info
export const DrawerFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid ${props => props.theme.colors.border.light};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: ${props => props.theme.colors.background.primary};
`

// Badge per count articoli
export const Badge = styled.span`
  background: ${props => props.theme.colors.semantic.primary};
  color: ${props => props.theme.colors.text.inverse};
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: 0.5rem;
`

// Info text nel footer
export const FooterText = styled.span`
  font-size: 0.875rem;
  color: ${props => props.theme.colors.text.secondary};
  font-family: ${props => props.theme.typography.fontFamily};
`

// Container per singolo articolo/servizio
export const ItemRow = styled.div`
  padding: 1rem;
  border: 1px solid ${props => props.isAdded
    ? props.theme.colors.semantic.success
    : props.theme.colors.border.medium};
  border-radius: 8px;
  margin-bottom: 0.75rem;
  background: ${props => props.isAdded
    ? props.theme.colors.semantic.successHover
    : props.theme.colors.background.secondary};
  transition: all 0.2s;

  &:hover {
    border-color: ${props => props.isAdded
      ? props.theme.colors.semantic.success
      : props.theme.colors.border.focus};
    box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.light};
  }
`

// Info principale (titolo, prezzo, etc)
export const ItemInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
`

// Parte sinistra (titolo + descrizione)
export const ItemMain = styled.div`
  flex: 1;
  min-width: 0;
`

// Titolo articolo
export const ItemTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
  margin: 0 0 0.25rem 0;
  font-family: ${props => props.theme.typography.fontFamily};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

// Descrizione/dettagli secondari
export const ItemDescription = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.colors.text.tertiary};
  margin: 0;
  font-family: ${props => props.theme.typography.fontFamily};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

// Prezzo a destra
export const ItemPrice = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
  margin-left: 1rem;
  font-family: ${props => props.theme.typography.fontFamily};
  white-space: nowrap;
`

// Actions row (quantità + buttons)
export const ItemActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
`

// Gruppo per quantità
export const QuantityGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

// Label quantità
export const QuantityLabel = styled.label`
  font-size: 0.75rem;
  color: ${props => props.theme.colors.text.tertiary};
  font-family: ${props => props.theme.typography.fontFamily};
`

// Input quantità
export const QuantityInput = styled.input`
  width: 70px;
  padding: 0.5rem 0.625rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: 6px;
  font-size: 0.875rem;
  text-align: center;
  font-family: inherit;
  color: ${props => props.theme.colors.text.primary};
  background: ${props => props.theme.colors.background.secondary};
  transition: ${props => props.theme.transitions.default};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.border.focus};
    background: ${props => props.theme.colors.background.primary};
  }

  /* Rimuove spinner */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
  appearance: textfield;
`

// Gruppo bottoni destra
export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

// Bottone info
export const InfoButton = styled.button`
  background: transparent;
  border: 1px solid ${props => props.theme.colors.border.medium};
  color: ${props => props.theme.colors.semantic.info};
  padding: 0.5rem;
  border-radius: ${props => props.theme.radius.button};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;

  &:hover {
    background: ${props => props.theme.colors.background.hover};
    border-color: ${props => props.theme.colors.semantic.info};
  }
`

// Bottone aggiungi
export const AddButton = styled.button`
  background: ${props => props.isAdded
    ? props.theme.colors.semantic.success
    : props.theme.colors.semantic.primary};
  color: ${props => props.theme.colors.text.inverse};
  border: none;
  padding: 0.5rem 1rem;
  border-radius: ${props => props.theme.radius.button};
  font-size: 0.875rem;
  font-weight: 500;
  font-family: ${props => props.theme.typography.fontFamily};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};
  display: flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;
  min-height: 36px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.medium};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`

// Empty state quando nessun risultato
export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: ${props => props.theme.colors.text.tertiary};
`

export const EmptyStateIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.3;
`

export const EmptyStateText = styled.p`
  font-size: 0.9375rem;
  margin: 0;
  font-family: ${props => props.theme.typography.fontFamily};
`
